import styled from 'styled-components';

/* Espelha components/UpdateModal/styled: mesma família tipográfica, mesmos paddings e
   mesmo rodapé alinhado à direita. As duas modais interrompem o usuário do mesmo jeito e
   precisam parecer a mesma coisa — divergir aqui faria a de sessão parecer phishing. */

export const Content = styled.div`
  padding: 20px;
`;

export const Message = styled.p`
  font-family: Blinker;
  font-size: 16px;
  line-height: 22px;
  color: #4d4d4d;
  margin: 0 0 16px;
`;

/** Identificação de quem está voltando. Read-only de propósito: a modal re-autentica a
 *  MESMA sessão. Trocar de usuário é o outro caminho ("Entrar com outra conta"), que
 *  passa por logout completo. */
export const Identificacao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  margin-bottom: 16px;
  border-radius: 6px;
  background: #f5f5f5;
`;

export const NomeUsuario = styled.span`
  font-family: Blinker;
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1b;
`;

export const LoginUsuario = styled.span`
  font-family: Blinker;
  font-size: 13px;
  color: #7a7a7a;
`;

/** Amarelo, não vermelho: "resta 1 tentativa" é aviso, não falha. O vermelho fica
 *  reservado para o erro da tentativa que acabou de falhar. */
export const AvisoUltimaTentativa = styled.p`
  font-family: Blinker;
  font-size: 13px;
  line-height: 18px;
  color: #8a6100;
  margin: 8px 0 0;
`;

export const ErroInline = styled.p`
  font-family: Blinker;
  font-size: 13px;
  line-height: 18px;
  color: #b00020;
  margin: 8px 0 0;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 20px 20px;

  button[type='submit'] {
    min-width: 120px;
  }
`;

/** Botão que parece link. É uma AÇÃO destrutiva de sessão (logout completo), então não
 *  pode competir visualmente com o "Continuar" — mas precisa ser alcançável por teclado,
 *  daí `button` e não `a`. */
export const LinkOutraConta = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: Blinker;
  font-size: 14px;
  color: #7a7a7a;
  text-decoration: underline;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: #4d4d4d;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
